import { Download } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/Button';
import { TaxonomyGetResponse } from '@/services/TaxonomiesService';

interface DownloadTaxonomyButtonProps {
  customerId: number;
  selectedVersion: string;
  displayedItems: TaxonomyGetResponse[];
  disabled?: boolean;
}

interface CsvRow {
  Category: string;
  Group: string;
  GroupName: string;
  Property: string;
  Description: string;
  Examples: string;
  PropertyOrder: string;
}

export function DownloadTaxonomyButton({
  customerId,
  selectedVersion,
  displayedItems,
  disabled,
}: DownloadTaxonomyButtonProps) {
  function handleDownloadCSV() {
    const headers = [
      'Category',
      'Group',
      'Group Name',
      'Property',
      'Description',
      'Examples',
      'Property Order',
    ];

    const csvRows: string[][] = [];
    csvRows.push(headers);

    for (let i = 0; i < displayedItems.length; i++) {
      const item = displayedItems[i];
      const row: CsvRow = {
        Category: item.categoryName ?? '',
        Group: item.type ?? '',
        GroupName: item.groupName ?? '',
        Property: item.property ?? '',
        Description: item.description ?? '',
        Examples: item.examples ?? '',
        PropertyOrder: item.order !== undefined ? String(item.order) : '',
      };

      const rowArray = [
        '"' + row.Category.replace(/"/g, '""') + '"',
        '"' + row.Group.replace(/"/g, '""') + '"',
        '"' + row.GroupName.replace(/"/g, '""') + '"',
        '"' + row.Property.replace(/"/g, '""') + '"',
        '"' + row.Description.replace(/"/g, '""') + '"',
        '"' + row.Examples.replace(/"/g, '""') + '"',
        '"' + row.PropertyOrder.replace(/"/g, '""') + '"',
      ];

      csvRows.push(rowArray);
    }

    const csvContent =
      '\uFEFF' +
      csvRows
        .map(function (row) {
          return row.join(',');
        })
        .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute(
      'download',
      'taxonomyCategory_' + customerId + '_v' + selectedVersion + '.csv',
    );
    link.setAttribute('href', url);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success('CSV file downloaded successfully.');
  }

  return (
    <Button
      variant="outline"
      onClick={handleDownloadCSV}
      className="flex items-center gap-2"
      disabled={disabled}
    >
      <Download className="h-4 w-4" />
      Download Taxonomy
    </Button>
  );
}
